import React from "react";
import {
  Page,
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  Layout,
  TextContainer,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function AreaFormSkeleton(props) {
  const { t } = useTranslation();
  return (
    <Page>
      <TitleBar
        title={t("common.loading")}
        breadcrumbs={props.breadcrumbs}
        secondaryActions={[
          {
            content: "Preview",
            loading: true,
          },
        ]}
      />
      <Layout>
        <Layout.Section>
          <Card>
            <Card.Section>
              <TextContainer>
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText />
              </TextContainer>
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText />
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.Section>
        <Layout.Section>
          <Card>
            <Card.Section>
              <SkeletonDisplayText size="small" />
            </Card.Section>
            <Card.Section>
              <TextContainer>
                <SkeletonBodyText lines={12} />
              </TextContainer>
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
